import React from "react"
import logoUrl from "../../../assets/img/payment-icons/shop_pay.svg"

export default function ShopPayLogo({ sx }: { sx: React.CSSProperties }) {
    return (
        <img
            src={logoUrl} loading="lazy"
            alt="Shop Pay logo"
            style={sx}
        />
    )
}
